import { useSelector } from 'react-redux'

import { selectCustomerNotificationsSettings } from '@/features/domain/territory'
import { NotificationFormValues } from '@/notificationForms'

export type CanceledNotificationValues = ReturnType<typeof useCanceledNotificationValues>

/**
 * That hook grabs canceledNotification values from the domain and returns them
 */
export function useCanceledNotificationValues(): NotificationFormValues {
  const notificationSettings = useSelector(selectCustomerNotificationsSettings)

  return {
    ...notificationSettings['canceledSettings'],
    windowOfCommitmentToleranceMins: '30',
    notificationCutoffMins: 0,
    proximityThresholdMins: '10',
    alwaysNotifyAfterCutoff: false,
    toleranceMins: 'No',
    windowOfCommitmentSnapToMins: 0,
  }
}
